import React, { useEffect, useState, useRef } from "react";
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import axios from "axios";
import API_BASE_URL from "../../../config";
import Swal from "sweetalert2";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Invoicetemplate from '../Orders/Invoicetemplate';
import PackingSlipTemplate from '../Orders/PackingSlipTemplate';
import { createRoot } from 'react-dom/client';
import "../../../../src/assets/css/Auth.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const OrdersList = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [orderIdFilter, setOrderIdFilter] = useState('');
  const [productFilter, setProductFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [priceOption, setPriceOption] = useState('');
  const [customMinPrice, setCustomMinPrice] = useState('');
  const [customMaxPrice, setCustomMaxPrice] = useState('');
  
  // Mobile-specific states
  const [mobileSearchTerm, setMobileSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  
  const token = localStorage.getItem("accessToken");
  // const tableRef = useRef(null);

  useEffect(() => {
    if (token) {
      axios.get(`${API_BASE_URL}api/home/orders/get_orders_list/`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
         console.log("📦 Orders Data:", response.data);
        response.data.forEach((order, idx) => {
          console.log(`Order ${idx + 1} Shipping Address:`, order.shipping_address);
        });
        
        // Sort orders by date (newest first)
        const sortedOrders = response.data.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        
        setOrders(sortedOrders);
        setFilteredOrders(sortedOrders);
      })
      .catch((error) => console.error("Error fetching orders:", error));
    }
  }, [token]);

  const handleEditClick = (order) => {
    setSelectedOrder({ ...order });
    setShowModal(true);
  };

  const handleExportExcel = () => {
    const dataToExport = getMobileFilteredOrders().map(order => ({
      OrderID: `GSA${order.id}`,
      Invoice: order.razorpay_order_id,
      Product: `${order.items[0]?.part_group_name}-${order.items[0]?.part_no}`,
      Date: new Date(order.created_at).toLocaleDateString(),
      Amount: order.total_price,
      Status: order.status
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    });

    saveAs(data, `Orders_Report.xlsx`);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedOrder(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!token) {
      Swal.fire({
        title: 'No Token',
        text: 'You are not logged in. Please login to continue.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }
    try {
      const response = await axios.put(
        `${API_BASE_URL}api/home/orders/${selectedOrder.id}/status/`,
        { status: selectedOrder.status },
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
  
      if (response.status === 200) {
        const updatedOrders = orders.map(o => 
          o.id === selectedOrder.id ? { ...o, status: response.data.new_status || selectedOrder.status } : o
        );
        
        // Keep the sorting (newest first) after update
        updatedOrders.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        
        setOrders(updatedOrders);
        applyAllFilters(updatedOrders);
        
        await Swal.fire({ 
          title: 'Status Updated', 
          text: 'Order status has been updated.', 
          icon: 'success', 
          confirmButtonText: 'OK' 
        });
        handleClose();
      } else {
        alert('Unexpected response');
      }
    } catch (err) {
      Swal.fire({ 
        title: 'Update Failed', 
        text: err.response?.data?.message || 'Try again.', 
        icon: 'error', 
        confirmButtonText: 'OK' 
      });
    }
  };

  useEffect(() => {
    applyAllFilters();
  }, [
    orders,
    startDate,
    endDate,
    orderIdFilter,
    productFilter,
    statusFilter,
    priceOption,
    customMinPrice,
    customMaxPrice,
  ]);

  const handlePrint = async (order) => {
    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.top = '0';
    document.body.appendChild(container);

    const company = {
      name: 'GowriSankar Agencies',
      logo: '/adminAssets/images/gallery/logo-light.png',
      addressLine1: 'PLOT NO.381, PHASE 1 & 2, INDIRA AUTONAGAR',
      cityState: 'Guntur, Andhra Pradesh',
      phone: '+91 92480 22760',
      signature: '/assets/img/signature.png'
    };

    const root = createRoot(container);
    root.render(<Invoicetemplate order={order} company={company} />);

    setTimeout(async () => {
      try {
        const canvas = await html2canvas(container, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const imgProps = pdf.getImageProperties(imgData);
        const imgHeight = (imgProps.height * pageWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, imgHeight);
        pdf.save(`Invoice_${order.razorpay_order_id}.pdf`);
      } catch (err) {
        console.error('Error generating invoice PDF:', err);
      } finally {
        root.unmount();
        container.remove();
      }
    }, 100);
  };

  const handlePackingSlipPrint = async (order) => {
    if (!order) return;

    const company = {
      name: 'GowriSankar Agencies',
      logo: '/adminAssets/images/gallery/logo-light.png',
      addressLine1: 'PLOT NO.381, PHASE 1 & 2, INDIRA AUTONAGAR',
      cityState: 'Guntur, Andhra Pradesh',
      phone: '+91 92480 22760',
      signature: '/assets/img/signature.png',
    };

    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.top = '0';
    document.body.appendChild(container);

    const root = createRoot(container);
    root.render(<PackingSlipTemplate order={order} company={company} />);

    setTimeout(async () => {
      try {
        const canvas = await html2canvas(container, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const imgProps = pdf.getImageProperties(imgData);
        const imgHeight = (imgProps.height * pageWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, imgHeight);
        pdf.save(`PackingSlip_${order.razorpay_order_id || order.id}.pdf`);
      } catch (err) {
        console.error('Error generating packing slip PDF:', err);
      } finally {
        root.unmount();
        container.remove();
      }
    }, 100);
  };

  const applyAllFilters = (ordersToFilter = orders) => {

    let filtered = [...ordersToFilter];

    // Date filter
    if (startDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);

      filtered = filtered.filter(order =>
        new Date(order.created_at) >= start
      );
    }

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);

      filtered = filtered.filter(order =>
        new Date(order.created_at) <= end
      );
    }

    // Order ID filter
    if (orderIdFilter) {
      filtered = filtered.filter(order =>
        `GSA${order.id}`
          .toLowerCase()
          .includes(orderIdFilter.toLowerCase())
      );
    }

    // Product filter
    if (productFilter) {
      filtered = filtered.filter(order =>
        `${order.items[0]?.part_group_name}-${order.items[0]?.part_no}`
          .toLowerCase()
          .includes(productFilter.toLowerCase())
      );
    }

    // Status filter
    if (statusFilter) {
      filtered = filtered.filter(order =>
        order.status.toLowerCase() === statusFilter.toLowerCase()
      );
    }

    // Price filter
    if (priceOption) {
      filtered = filtered.filter(order => {
        const price = parseFloat(order.total_price);

        if (priceOption === '0-1000') {
          return price >= 0 && price <= 1000;
        }

        if (priceOption === '1000-5000') {
          return price > 1000 && price <= 5000;
        }

        if (priceOption === '5000-10000') {
          return price > 5000 && price <= 10000;
        }

        if (priceOption === '10000+') {
          return price > 10000;
        }

        if (priceOption === 'custom') {
          const min = parseFloat(customMinPrice) || 0;
          const max = parseFloat(customMaxPrice) || Infinity;
          return price >= min && price <= max;
        }

        return true;
      });
    }

    // Sort newest first
    filtered.sort((a, b) =>
      new Date(b.created_at) - new Date(a.created_at)
    );

    setFilteredOrders(filtered);
    setCurrentPage(1);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    applyAllFilters();
  };

  const handleResetFilter = () => {

    setStartDate('');
    setEndDate('');
    setOrderIdFilter('');
    setProductFilter('');
    setStatusFilter('');
    setPriceOption('');
    setCustomMinPrice('');
    setCustomMaxPrice('');
    setMobileSearchTerm('');
    setCurrentPage(1);

    const sortedOrders = [...orders].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    setFilteredOrders(sortedOrders);
  };

  // Mobile search functionality
  const handleMobileSearch = (e) => {
    const searchValue = e.target.value;
    setMobileSearchTerm(searchValue);
    setCurrentPage(1); // Reset to first page when searching
  };

  // Get filtered orders based on mobile search
  const getMobileFilteredOrders = () => {
    if (!mobileSearchTerm) return filteredOrders;

    const searchLower = mobileSearchTerm.toLowerCase();
    return filteredOrders.filter(order => {
      const orderId = `GSA${order.id}`.toLowerCase();
      const invoiceId = order.razorpay_order_id?.toLowerCase() || '';
      const productName = `${order.items[0]?.part_group_name}-${order.items[0]?.part_no}`.toLowerCase();
      const status = order.status?.toLowerCase() || '';
      const amount = order.total_price?.toString() || '';

      return (
        orderId.includes(searchLower) ||
        invoiceId.includes(searchLower) ||
        productName.includes(searchLower) ||
        status.includes(searchLower) ||
        amount.includes(searchLower)
      );
    });
  };

  // Get current page orders for mobile
  const getCurrentPageOrders = () => {
    const searchFiltered = getMobileFilteredOrders();
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return searchFiltered.slice(indexOfFirstItem, indexOfLastItem);
  };

  // Get total pages for mobile
  const getTotalPages = () => {
    const searchFiltered = getMobileFilteredOrders();
    return Math.ceil(searchFiltered.length / itemsPerPage);
  };

  // Pagination handlers
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Scroll to top of orders list on mobile
    if (window.innerWidth < 992) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < getTotalPages()) {
      handlePageChange(currentPage + 1);
    }
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const totalPages = getTotalPages();
    const pageNumbers = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers;
  };

  const getStatusBadgeClass = (status) => {
    const statusLower = status?.toLowerCase();
    switch(statusLower) {
      case 'pending': return 'badge-yellow';
      case 'confirmed': return 'badge-green';
      case 'completed': return 'badge-pink';
      case 'progress': return 'badge-blue';
      case 'failed':
      case 'cancelled': return 'badge-red';
      default: return '';
    }
  };

  const currentPageOrders = getCurrentPageOrders();
  const totalPages = getTotalPages();
  const mobileFilteredCount = getMobileFilteredOrders().length;

  return (
    <div className="card basic-data-table">
      <div className="card-body">
        {/* Date Filter Form - Mobile Optimized */}
        <div className="mb-5 p-3 border rounded bg-light">
          <h6 className="mb-3">Filter Orders by Date</h6>

          <form onSubmit={handleFilterSubmit} >
            <div className="row g-3">
              {/* Date Inputs */}
              <div className="col-md-4 col-12">
                <label htmlFor="startDate" className="form-label">Start Date</label>
                <input
                  type="date"
                  id="startDate"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>

              <div className="col-md-4 col-12">
                <label htmlFor="endDate" className="form-label">End Date</label>
                <input
                  type="date"
                  id="endDate"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>

              {/* Buttons - Desktop */}
              <div className="col-md-4 d-none d-md-flex align-items-end gap-4">
                {/* <button
                  type="submit"
                  className="btn-theme-admin btn-primary me-2 d-inline-flex align-items-center"
                >
                  <Icon icon="mdi:filter" className="me-1" />
                  <span>Apply Filter</span>
                </button> */}

                <button
                  type="button"
                  className="btn-theme-admin btn-secondary d-inline-flex align-items-center"
                  onClick={handleResetFilter}
                >
                  <Icon icon="mdi:refresh" className="me-1" />
                  <span>Reset</span>
                </button>

                <button
                  className="btn-theme-admin btn-primary me-2 d-inline-flex align-items-center"
                  onClick={handleExportExcel}
                >
                  Export to Excel
                </button>
              </div>

              {/* Buttons - Mobile (Full Width) */}
              <div className="col-12 d-md-none">
                <div className="d-flex gap-2">
                  {/* <button
                    type="submit"
                    className="btn-theme-admin btn-primary flex-grow-1 d-inline-flex align-items-center justify-content-center"
                  >
                    <Icon icon="mdi:filter" className="me-1" />
                    <span>Apply</span>
                  </button> */}

                  <button
                    type="button"
                    className="btn-theme-admin btn-secondary flex-grow-1 d-inline-flex align-items-center justify-content-center"
                    onClick={handleResetFilter}
                  >
                    <Icon icon="mdi:refresh" className="me-1" />
                    <span>Reset</span>
                  </button>

                  <button
                    className="btn-theme-admin btn-secondary flex-grow-1 d-inline-flex align-items-center justify-content-center"
                    onClick={handleExportExcel}
                  >
                    Export to Excel
                  </button>

                </div>
              </div>
            </div>
          </form>

          {(startDate || endDate) && (
            <div className="mt-3">
              <small className="text-muted">
                Showing {filteredOrders.length} of {orders.length} orders
              </small>
            </div>
          )}
        </div>

        <div className="row mb-3 d-flex gap-3 align-items-center">
          <div className="col-md-2">
            <input type="text" className="form-control" placeholder="Order ID" value={orderIdFilter} onChange={(e) => setOrderIdFilter(e.target.value)} />
          </div>

          <div className="col-md-3">
            <input type="text" className="form-control" placeholder="Product Name" value={productFilter} onChange={(e) => setProductFilter(e.target.value)} />
          </div>

          <div className="col-md-2">
            <select id="statusFilter" className="form-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
              <option value="">All Status</option>
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="progress">Progress</option>
              <option value="failed">Failed</option>
              <option value="cancelled">Cancelled</option>
              <option value="completed">Completed</option>
            </select>
          </div>

          <div className="col-md-3">

            <select
              className="form-select"
              value={priceOption}
              onChange={(e) => {
                setPriceOption(e.target.value);
                setCustomMinPrice('');
                setCustomMaxPrice('');
              }}
            >
              <option value="">All Prices</option>
              <option value="0-1000">₹0 - ₹1,000</option>
              <option value="1000-5000">₹1,001 - ₹5,000</option>
              <option value="5000-10000">₹5,001 - ₹10,000</option>
              <option value="10000+">Above ₹10,000</option>
              <option value="custom">Custom Range</option>
            </select>

            {priceOption === 'custom' && (
              <div className="d-flex gap-2 mt-2">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Min"
                  value={customMinPrice}
                  onChange={(e) => setCustomMinPrice(e.target.value)}
                />
                <input
                  type="number"
                  className="form-control"
                  placeholder="Max"
                  value={customMaxPrice}
                  onChange={(e) => setCustomMaxPrice(e.target.value)}
                />
              </div>
            )}
          </div>
        </div>

        {/* Desktop Table View */}
        <div className="table-responsive d-none d-lg-block">
          <table className="table bordered-table mb-0 sm-table" id="ordersDataTable">
            <thead>
              <tr>
                <th>S.L</th>
                <th>Order id</th>
                <th>Invoice</th>
                <th>Name</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentPageOrders.map((order, idx) => (
                <tr key={order.id}>
                  <td>{String(idx + 1).padStart(2, '0')}</td>
                  <td>GSA{order.id}</td>
                  <td>#{order.razorpay_order_id}</td>
                  <td>{order.items[0]?.part_group_name}-{order.items[0]?.part_no}</td>
                  <td>{new Date(order.created_at).toLocaleDateString()}</td>
                  <td>₹{order.total_price}</td>
                  <td>
                    <span className={getStatusBadgeClass(order.status)}>
                      {order.status}
                    </span>
                  </td>
                  <td>
                    <Link 
                      to="#" 
                      onClick={() => handleEditClick(order)}
                      className="action-icon"
                      data-tooltip="Edit Order"
                    >
                      <Icon icon="lucide:edit" />
                    </Link>
                    &nbsp;&nbsp;&nbsp;
                    <Link 
                      to="#" 
                      onClick={() => handlePrint(order)}
                      className="action-icon"
                      data-tooltip="Download Invoice"
                    >
                      <Icon icon="mdi:file-document-outline" />
                    </Link>
                    &nbsp;&nbsp;&nbsp;
                    <Link 
                      to="#" 
                      onClick={() => handlePackingSlipPrint(order)}
                      className="action-icon"
                      data-tooltip="Download Packing Slip"
                    >
                      <Icon icon="mdi:package-variant-closed" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalPages > 1 && (
            <div className="pagination-container mt-3">
              <nav>
                <ul className="pagination-list">
                  <li>
                    <button
                      className="pagination-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(prev => prev - 1)}
                    >
                      Prev
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page}>
                      <button
                        className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  <li>
                    <button
                      className="pagination-btn"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(prev => prev + 1)}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>

        {/* Mobile Card View */}
        <div className="d-lg-none">
          {/* Mobile Search Bar */}
          <div className="mb-3">
            <div className="position-relative">
              {/* <input
                type="text"
                className="form-control ps-5"
                placeholder="Search orders by ID, invoice, product, status..."
                value={mobileSearchTerm}
                onChange={handleMobileSearch}
              />
              <Icon 
                icon="mdi:magnify" 
                className="position-absolute text-muted"
                style={{ 
                  left: '12px', 
                  top: '50%', 
                  transform: 'translateY(-50%)',
                  fontSize: '20px'
                }}
              /> */}
              {mobileSearchTerm && (
                <button
                  type="button"
                  className="btn btn-link position-absolute text-muted p-0"
                  style={{ 
                    right: '12px', 
                    top: '50%', 
                    transform: 'translateY(-50%)'
                  }}
                  onClick={() => {
                    setMobileSearchTerm('');
                    setCurrentPage(1);
                  }}
                >
                  <Icon icon="mdi:close-circle" style={{ fontSize: '20px' }} />
                </button>
              )}
            </div>
            
            {/* Search Results Info */}
            {mobileSearchTerm && (
              <div className="mt-2">
                <small className="text-muted">
                  Found {mobileFilteredCount} order{mobileFilteredCount !== 1 ? 's' : ''}
                </small>
              </div>
            )}
          </div>

          {/* Order Cards */}
          {currentPageOrders.length > 0 ? (
            <>
              {currentPageOrders.map((order, idx) => {
                const globalIndex = (currentPage - 1) * itemsPerPage + idx;
                return (
                  <div key={order.id} className="card mb-3 shadow-sm border">
                    <div className="card-body p-3">
                      {/* Header with Order ID and Status */}
                      <div className="d-flex justify-content-between align-items-start mb-3 pb-3 border-bottom">
                        <div>
                          <h6 className="mb-1 fw-bold text-theme">GSA{order.id}</h6>
                          <small className="text-muted">#{order.razorpay_order_id}</small>
                        </div>
                        <span className={`${getStatusBadgeClass(order.status)} px-2 py-1 text-xs`}>
                          {order.status}
                        </span>
                      </div>

                      {/* Order Details */}
                      <div className="row g-2 mb-3">
                        <div className="col-12">
                          <div className="d-flex align-items-start">
                            <Icon icon="mdi:package-variant" className="text-muted mt-1 me-2 flex-shrink-0" />
                            <div className="flex-grow-1">
                              <small className="text-muted d-block">Product</small>
                              <span className="text-sm fw-medium">
                                {order.items[0]?.part_group_name}-{order.items[0]?.part_no}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="d-flex align-items-start">
                            <Icon icon="mdi:calendar-outline" className="text-muted mt-1 me-2 flex-shrink-0" />
                            <div>
                              <small className="text-muted d-block">Date</small>
                              <span className="text-sm fw-medium">
                                {new Date(order.created_at).toLocaleDateString('en-US', {
                                  month: 'short',
                                  day: 'numeric',
                                  year: 'numeric'
                                })}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="d-flex align-items-start">
                            <Icon icon="mdi:currency-inr" className="text-muted mt-1 me-2 flex-shrink-0" />
                            <div>
                              <small className="text-muted d-block">Amount</small>
                              <span className="text-sm fw-bold text-success">₹{order.total_price}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="d-flex gap-2 py-4 border-top">
                        <button
                          type="button"
                          className=" btn-theme-admin btn-outline-primary flex-grow-1 d-flex align-items-center justify-content-center gap-1"
                          onClick={() => handleEditClick(order)}
                        >
                          <Icon icon="lucide:edit" />
                          <span className="d-none d-sm-inline">Edit</span>
                        </button>
                        
                        <button
                          type="button"
                          className=" btn-theme-admin d-flex align-items-center justify-content-center"
                          onClick={() => handlePrint(order)}
                          title="Download Invoice"
                        >
                          <Icon icon="mdi:file-document-outline" />
                        </button>
                        
                        <button
                          type="button"
                          className=" btn-theme-admin btn-outline-info d-flex align-items-center justify-content-center"
                          onClick={() => handlePackingSlipPrint(order)}
                          title="Download Packing Slip"
                        >
                          <Icon icon="mdi:package-variant-closed" />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Mobile Pagination */}
              {totalPages > 1 && (
                <div className="pagination-container">
                  {/* Pagination Controls */}
                  <nav aria-label="Page navigation">
                    <ul className="pagination-list">
                      {/* Previous Button */}
                      <li className="pagination-item">
                        <button
                          className={`pagination-btn pagination-prev ${currentPage === 1 ? 'disabled' : ''}`}
                          onClick={handlePrevPage}
                          disabled={currentPage === 1}
                          aria-label="Previous page"
                        >
                          <Icon icon="mdi:chevron-left" />
                        </button>
                      </li>

                      {/* Page Numbers */}
                      {getPageNumbers().map((pageNum, idx) => (
                        pageNum === '...' ? (
                          <li key={`ellipsis-${idx}`} className="pagination-item pagination-ellipsis">
                            <span>...</span>
                          </li>
                        ) : (
                          <li key={pageNum} className="pagination-item">
                            <button
                              className={`pagination-btn pagination-number ${currentPage === pageNum ? 'active' : ''}`}
                              onClick={() => handlePageChange(pageNum)}
                              aria-label={`Page ${pageNum}`}
                              aria-current={currentPage === pageNum ? 'page' : undefined}
                            >
                              {pageNum}
                            </button>
                          </li>
                        )
                      ))}

                      {/* Next Button */}
                      <li className="pagination-item">
                        <button
                          className={`pagination-btn pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}
                          onClick={handleNextPage}
                          disabled={currentPage === totalPages}
                          aria-label="Next page"
                        >
                          <Icon icon="mdi:chevron-right" />
                        </button>
                      </li>
                    </ul>
                  </nav>

                  {/* Page Info */}
                  <div className="pagination-info">
                    <span className="pagination-text">
                      Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                    </span>
                    <span className="pagination-separator">•</span>
                    <span className="pagination-text">
                      <strong>{mobileFilteredCount}</strong> total orders
                    </span>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="text-center py-5">
              <Icon icon="mdi:package-variant-closed-remove" className="text-secondary-light" style={{ fontSize: '64px' }} />
              <p className="text-secondary-light mt-3 mb-0">
                {mobileSearchTerm ? "No orders found matching your search" :
                 startDate || endDate ? "No orders found for the selected date range" : "No orders found"}
              </p>
              {mobileSearchTerm && (
                <button
                  className="btn btn-sm btn-outline-primary mt-3"
                  onClick={() => {
                    setMobileSearchTerm('');
                    setCurrentPage(1);
                  }}
                >
                  Clear Search
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Edit Order Modal */}
      {showModal && selectedOrder && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Order</h5>
                <button onClick={handleClose} className="btn-close">X</button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Order ID</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={`GSA${selectedOrder.id}`} 
                      disabled 
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Invoice ID</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={`#${selectedOrder.razorpay_order_id}`} 
                      disabled 
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select 
                      name="status" 
                      value={selectedOrder.status} 
                      onChange={handleChange} 
                      className="form-select"
                    >
                      <option value="pending">Pending</option>
                      <option value="confirmed">Confirmed</option>
                      <option value="progress">Progress</option>
                      <option value="failed">Failed</option>
                      <option value="cancelled">Cancelled</option>
                      <option value="completed">Completed</option>
                    </select>
                  </div>

                  {/* Desktop Button Layout */}
                  <div className="text-end d-none d-sm-block">
                    <button 
                      type="button" 
                      className="btn-theme-admin me-3" 
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button 
                      type="button" 
                      className="btn-theme-admin" 
                      onClick={handleSave}
                    >
                      Save Changes
                    </button>
                  </div>

                  {/* Mobile Button Layout */}
                  <div className="d-sm-none d-flex flex-column gap-2">
                    <button 
                      type="button" 
                      className="btn-theme-admin w-100" 
                      onClick={handleSave}
                    >
                      Save Changes
                    </button>
                    <button 
                      type="button" 
                      className="btn-theme-admin w-100" 
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Responsive Styles */}
      <style jsx>{`
        @media (max-width: 991px) {
          .card-body {
            padding: 16px !important;
          }
          
          .badge-yellow,
          .badge-green,
          .badge-pink,
          .badge-blue,
          .badge-red {
            font-size: 0.7rem;
            padding: 4px 8px;
            border-radius: 4px;
          }
        }
        
        @media (max-width: 576px) {
          .modal-dialog {
            margin: 0.5rem;
          }
          
          .modal-body {
            padding: 1rem;
          }
          
          .modal-header h5 {
            font-size: 1rem;
          }
          
          .filter-section {
            padding: 12px !important;
          }
        }

        /* Search input styling */
        .form-control:focus {
          border-color: #86b7fe;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }

        /* ===== Modern Pagination Styles ===== */
        .pagination-container {
          margin-top: 2rem;
          padding: 1.25rem 1rem;
          background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
          border-radius: 12px;
          border: 1px solid #e9ecef;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

        .pagination-list {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin: 0;
          padding: 0;
          list-style: none;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }

        .pagination-item {
          display: inline-flex;
        }

        .pagination-btn {
          min-width: 40px;
          height: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #dee2e6;
          background: #ffffff;
          color: #495057;
          font-size: 0.875rem;
          font-weight: 500;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          padding: 0 12px;
          position: relative;
          overflow: hidden;
        }

        .pagination-btn:hover:not(.disabled) {
          background: #0068a5;
          color: #ffffff;
          border-color: #0068a5;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 104, 165, 0.3);
        }

        .pagination-btn.active {
          background: linear-gradient(135deg, #0068a5 0%, #005a8c 100%);
          color: #ffffff;
          border-color: #0068a5;
          box-shadow: 0 4px 12px rgba(13, 110, 253, 0.4);
          font-weight: 600;
        }

        .pagination-btn.disabled {
          background: #f8f9fa;
          color: #adb5bd;
          border-color: #e9ecef;
          cursor: not-allowed;
          opacity: 0.6;
        }

        .pagination-prev,
        .pagination-next {
          font-size: 1.2rem;
          padding: 0;
          width: 40px;
        }

        .pagination-ellipsis {
          display: inline-flex;
          align-items: center;
          padding: 0 8px;
          color: #6c757d;
          font-weight: 500;
          user-select: none;
        }

        .pagination-info {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
          padding-top: 0.75rem;
          border-top: 1px solid #e9ecef;
        }

        .pagination-text {
          font-size: 0.813rem;
          color: #6c757d;
          line-height: 1.5;
        }

        .pagination-text strong {
          color: #212529;
          font-weight: 600;
        }

        .pagination-separator {
          color: #dee2e6;
          font-weight: 300;
          user-select: none;
        }

        /* Responsive adjustments */
        @media (max-width: 576px) {
          .pagination-container {
            padding: 1rem 0.75rem;
          }

          .pagination-btn {
            min-width: 36px;
            height: 36px;
            font-size: 0.813rem;
            padding: 0 10px;
          }

          .pagination-prev,
          .pagination-next {
            width: 36px;
            font-size: 1.1rem;
          }

          .pagination-list {
            gap: 4px;
          }

          .pagination-info {
            font-size: 0.75rem;
            gap: 6px;
          }
        }

        @media (max-width: 380px) {
          .pagination-btn {
            min-width: 32px;
            height: 32px;
            font-size: 0.75rem;
            padding: 0 8px;
          }

          .pagination-prev,
          .pagination-next {
            width: 32px;
            font-size: 1rem;
          }

          .pagination-list {
            gap: 3px;
          }
        }

        /* Animation for page change */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .card.mb-3 {
          animation: fadeIn 0.3s ease;
        }

        /* Smooth transitions */
        .card {
          transition: all 0.2s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default OrdersList;